export const WORKPLAN_GET_WORKPLAN_BEGIN = 'WORKPLAN_GET_WORKPLAN_BEGIN';
export const WORKPLAN_GET_WORKPLAN_SUCCESS = 'WORKPLAN_GET_WORKPLAN_SUCCESS';
export const WORKPLAN_GET_WORKPLAN_FAILURE = 'WORKPLAN_GET_WORKPLAN_FAILURE';
export const WORKPLAN_GET_WORKPLAN_DISMISS_ERROR = 'WORKPLAN_GET_WORKPLAN_DISMISS_ERROR';
export const WORKPLAN_FORMAT_WORKPACKAGES = 'WORKPLAN_FORMAT_WORKPACKAGES';
export const WORKPLAN_SET_LOADING = 'WORKPLAN_SET_LOADING';



// WEBPACK FOOTER //
// ./src/features/workplan/redux/constants.js